import { Linkedin, Github, Mail, Phone, Voicemail as VoicemailIcon } from "lucide-react";
import { Section, Reveal } from "@/components/primitives";
import { contact, links } from "@/config";
import { useVoice } from "@/context/VoiceContext";
import Voicemail from "@/components/Voicemail";

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M18.244 2H21.5l-7.5 8.57L22.5 22h-6.9l-5.4-7.06L3.9 22H.64l8.02-9.17L.5 2h7.08l4.88 6.45L18.244 2Zm-1.21 18h1.8L7.05 3.9H5.12L17.03 20Z" />
  </svg>
);

export default function Contact() {
  const { voicemailOpen, setVoicemailOpen } = useVoice();
  const btn = "btn btn-outline !px-5 text-sm";
  return (
    <Section id="contact" tone="noir">
      <Reveal className="mx-auto flex max-w-3xl flex-col items-center text-center">
        <div className="relative mb-10 grid h-20 w-20 place-items-center" aria-hidden="true">
          <span className="pulse-ring absolute inset-0 rounded-full border border-gold/40" />
          <span className="absolute inset-2 rounded-full border border-gold/25" />
          <Phone className="h-7 w-7 text-gold" strokeWidth={1.4} />
        </div>
        <h2 className="font-serif text-3xl leading-[1.12] text-cream sm:text-4xl lg:text-5xl">{contact.headline}</h2>
        <p className="mt-6 font-serif text-2xl italic text-gold sm:text-3xl">{contact.callout}</p>
        <p className="mt-4 text-base text-gray2 md:text-lg">{contact.subline}</p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <a data-testid="contact-linkedin" href={links.linkedin} target="_blank" rel="noreferrer" className={btn}><Linkedin className="h-4 w-4" /> LinkedIn</a>
          <a data-testid="contact-github" href={links.github} target="_blank" rel="noreferrer" className={btn}><Github className="h-4 w-4" /> GitHub</a>
          <a data-testid="contact-email" href={links.email ? `mailto:${links.email}` : undefined} onClick={(e) => !links.email && (e.preventDefault(), setVoicemailOpen(true))} className={btn}><Mail className="h-4 w-4" /> Email</a>
          <a data-testid="contact-x" href={links.x} target="_blank" rel="noreferrer" className={btn}><XIcon className="h-4 w-4" /> X</a>
          <button data-testid="contact-voicemail" onClick={() => setVoicemailOpen(!voicemailOpen)} className="btn btn-red">
            <VoicemailIcon className="h-4 w-4" /> {contact.voicemailCta}
          </button>
        </div>
      </Reveal>
      <Voicemail open={voicemailOpen} onClose={() => setVoicemailOpen(false)} />
    </Section>
  );
}
